import { useState } from 'react'
import { ConnectStoresRow } from './types'

// Row init is the caller's (the two screens differ); update logic is shared.
export const useStoreLinkRows = (
  initRows: () => Record<string, ConnectStoresRow>
) => {
  const [rows, setRows] = useState<Record<string, ConnectStoresRow>>(initRows)

  const updateRow = (storeId: string, patch: Partial<ConnectStoresRow>) => {
    setRows((current) => ({
      ...current,
      [storeId]: { ...current[storeId], ...patch }
    }))
  }

  return { rows, updateRow }
}
